import { FunctionComponent } from 'react';
import { Layout } from './HomePageScreen.styles';
import { BeInformedBrick } from '../components/BeInformedBrick/BeInformedBrick';
import { PropertyDataBrick } from '../components/PropertyDataBrick/PropertyDataBrick';
import { SeoFooterTabs } from '@property.com.au/ui-kit';
import { seoFooterTabs } from '../../helpers/seoFooterTabs';
import { SearchBrick } from '../components/SearchBrick/SearchBrick';

const HomePageScreen: FunctionComponent = () => {
  return (
    <Layout>
      <SearchBrick />
      <PropertyDataBrick />
      <BeInformedBrick />
      <SeoFooterTabs tabs={seoFooterTabs} />
    </Layout>
  );
};

export default HomePageScreen;
